/* unplugin-vue-components disabled */import script from "./PrivacyAgreementNoEncrypt.vue?vue&type=script&lang=ts&setup=true"
export * from "./PrivacyAgreementNoEncrypt.vue?vue&type=script&lang=ts&setup=true"

import "./PrivacyAgreementNoEncrypt.vue?vue&type=style&index=0&id=22527e50&lang=less&scoped=true"

import exportComponent from "/Users/zhaoshunchen/Desktop/job/sinosig/workspace/shuke/sinosig-app-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22527e50"]])

export default __exports__